angular.module('bmsApp.employee').controller('EmployeeViewWorkHistoryCtrl', function ($state,
																					  $scope,
																					  ngTableParams,
																					  MMJobPartSvc) {

	$scope.tabs.workHistory.select = function () {
		$scope.tabs.workHistory.load();
	};

	$scope.tabs.workHistory.load = function () {
		if ($scope.tabs.workHistory.loaded !== true) {
			var rangePickerConfig = angular.copy($scope.config.datePicker.range);
			rangePickerConfig.options.opens = 'left';

			$scope.mmWorkHistory = {
				rangePickerConfig: rangePickerConfig,
				employeeId: $state.params.employeeId,
				filters: {
					dateRange: {
						startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
						endDate: moment().format('YYYY-MM-DD')
					}
				},
				applyFilter: function () {
					$scope.mmWorkHistory.tableParams.$params.filter = angular.extend($scope.mmWorkHistory.tableParams.$params.filter, {
						fromDate: $scope.mmWorkHistory.filters.dateRange.startDate,
						toDate: $scope.mmWorkHistory.filters.dateRange.endDate
					});
				},
				tableParams: new ngTableParams({
					page: 1,
					count: $scope.config.tabbedTable.params.count,
					sorting: {
						job_date: 'desc'
					}
				}, {
					counts: $scope.config.tabbedTable.settings.counts,
					getData: function ($defer, params) {
						$scope.mmWorkHistory.loading = true;
						var customerId = $scope.mmWorkHistory.employeeId;
						MMJobPartSvc.employeeWorkHistory(customerId, params.$params).then(function (response) {
							$defer.resolve(response.data.jobPartCollection);
							params.total(response.data.jobPartCount);
							$scope.mmWorkHistory.loading = false;
						});
					}
				})
			};

			$scope.mmWorkHistory.applyFilter();

			$scope.tabs.workHistory.loaded = true;
		}
	};
});
